import * as React from "react";
import { PointCardBox } from "./PointCard.style";
import { getPoints } from "../../../../services/api";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

interface IProps {
  adminDetails: any;
  userPoints: any[];
  isPointChecked: boolean;
  handleChange: (arg: any) => void;
  totalAmount: number;
  updatedCartTotal: number;
  userPointDetails: any;
  gateWayDetails: any;
  setUserPointDetail: React.Dispatch<React.SetStateAction<any>>;
}

export const PointCard: React.FC<IProps> = ({
  adminDetails,
  isPointChecked = false,
  handleChange,
  totalAmount,
  userPointDetails,
  setUserPointDetail,
  updatedCartTotal,
  gateWayDetails,
  userPoints,
}) => {
  const [pointValue, setPointValue] = React.useState<number | string>(0);
  const [hasValue, setHasValue] = React.useState<boolean>(false);
  const [invalidPoint, setInvalidPoint] = React.useState<any>({
    isError: false,
    errorMessage: "",
  });
  // const pointInputRef = React.useRef<any>(null);

  /**
   * This Effect runs to update the point
   * when reward is applied after a point
   * subtract the excess point from total amount to checkout
   */
  React.useEffect(() => {
    if (updatedCartTotal < 0) {
      const updatedPoint = Number(pointValue) + updatedCartTotal;
      // update point across board
      updatePointGlobally(updatedPoint);
    }
  }, [updatedCartTotal]);

  /**
   * Run this effect when point is unchecked
   * Reset point value to Zero
   */
  React.useEffect(() => {
    if (!isPointChecked) {
      updatePointGlobally(0);
    }
  }, [isPointChecked]);

  const updatePointGlobally = (updatedPoint: number) => {
    // update input value
    setPointValue(updatedPoint === 0 ? "" : updatedPoint);
    // update parent point value
    handleChange(updatedPoint);
  };

  const validatePointMinAndMaxValue = (event: any, maxNumber: number) => {
    let value = event.target.value;
    const minValue = 0;
    const maxValue = maxNumber;

    setPointValue(value);

    console.log("Point value", value);

    if (value < minValue) {
      setInvalidPoint({
        isError: true,
        errorMessage: "Invalid input, enter value above 0 points",
      });
      event.target.value = "";
    } else if (value > maxValue) {
      setInvalidPoint({
        isError: true,
        errorMessage:
          "Invalid input, Points cannot be more than your cart total",
      });
      return;
      // event.target.value = event.target.value.slice(0, -1);
    } else if (
      value >
      getCurrentPoint(
        userPointDetails?.earnedBalance,
        userPointDetails?.spentBalance
      )
    ) {
      setInvalidPoint({
        isError: true,
        errorMessage: `Insufficient points, enter point less than ${getCurrentPoint(
          userPointDetails?.earnedBalance,
          userPointDetails?.spentBalance
        )}`,
      });
      event.target.value = event.target.value.slice(0, -1);
    } else {
      setInvalidPoint({
        isError: false,
        errorMessage: "",
      });
    }
  };

  const getCurrentPoint = (earnedPoint: number, spentPoint: number) => {
    return earnedPoint - spentPoint;
  };

  const handleSelectMerchantPoint = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    const selectedPoint = userPoints.find(
      (_el) => _el.merchantUniqueReferenceNumber === value
    );
    // console.log({ value, selectedPoint });
    setUserPointDetail(selectedPoint);
  };

  return (
    <PointCardBox>
      <RadioGroup
        name="merchantPoint"
        onChange={handleSelectMerchantPoint}
        className="!w-full !flex flex-col gap-3">
        {userPoints.map((merchantPoint, id) => (
          <FormControlLabel
            key={id}
            className="!w-full !m-0"
            sx={{ "& .MuiFormControlLabel-label": { width: "100%" } }}
            label={
              <div className="card w-full trans px-4 py-3 rounded-lg cursor-pointer">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="inline-flex items-center gap-2 ml-[-0.25rem]">
                    <Radio
                      className="!p-1"
                      value={merchantPoint?.merchantUniqueReferenceNumber}
                      checked={
                        merchantPoint?.merchantUniqueReferenceNumber ===
                        userPointDetails?.merchantUniqueReferenceNumber
                      }
                    />

                    <h3 className="title mb-0 uppercase font-semibold">
                      {adminDetails?.uniqueReferenceNumber ===
                      merchantPoint?.merchantUniqueReferenceNumber
                        ? "Paycurra"
                        : gateWayDetails?.companyName}{" "}
                    </h3>
                  </div>

                  <div
                    className={`
                    ${
                      merchantPoint?.merchantUniqueReferenceNumber ===
                      userPointDetails?.merchantUniqueReferenceNumber
                        ? "opacity-100"
                        : "opacity-0"
                    }
                   trans balance d-inline-flex align-items-center`}>
                    <span>Bal:</span>
                    <div className="ms-2 me-1">
                      {getCurrentPoint(
                        userPointDetails?.earnedBalance,
                        userPointDetails?.spentBalance
                      ) - (pointValue as number) || 0}
                    </div>
                    <div>
                      Point
                      <>
                        {getCurrentPoint(
                          userPointDetails?.earnedBalance,
                          userPointDetails?.spentBalance
                        ) >= 1
                          ? "s"
                          : ""}
                      </>
                    </div>
                  </div>
                </div>

                {merchantPoint?.merchantUniqueReferenceNumber ===
                  userPointDetails?.merchantUniqueReferenceNumber && (
                  <div className="inputHolder mt-2 ml-auto">
                    <input
                      // ref={pointInputRef}
                      type={"number"}
                      placeholder="Enter Points you want to redeem"
                      className="w-full"
                      required={isPointChecked}
                      autoFocus={isPointChecked}
                      value={pointValue}
                      onChange={(e) => {
                        e.target.value.length >= 1
                          ? setHasValue(true)
                          : setHasValue(false);
                        // point validation
                        validatePointMinAndMaxValue(e, totalAmount);
                        setPointValue(e.target.value);
                        // Sending point to parentr
                        handleChange(e.target.value);
                      }}
                      readOnly={!isPointChecked}
                      pattern="[0-9]"
                    />
                    {invalidPoint.isError && (
                      <small className="errorMessage mt-1">
                        {invalidPoint.errorMessage}
                      </small>
                    )}

                    {isPointChecked && !hasValue && (
                      <small className="errorMessage mt-1">
                        Please enter point to apply
                      </small>
                    )}
                  </div>
                )}
              </div>
            }
            control={
              <Radio
                value={merchantPoint?.merchantUniqueReferenceNumber}
                className="!hidden"
              />
            }
          />
        ))}
      </RadioGroup>
    </PointCardBox>
  );
};
